import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import withLoading from '../../../utils/composition/withLoading';
import { dataProps, paginationProps } from '../../../data/enums/Component';
import { PanelStyled } from '../../common/configuration';
import { Pagination } from '../../../v4/components';
import CustomSelect from '../../../components/CustomSelect';
import StockLedgerStyled from './StockLedgerStyled';
import { TableHeader } from './tableConfig';
import CTAccordionStyled from '../../../components/CollapsibleTable/CTAccordionStyled';
import Detail from './detail';

const propTypes = {
  data: dataProps.value,
  onIconClick: PropTypes.func,
  onPageChange: PropTypes.func,
  pagination: paginationProps.value,
  distributorList: PropTypes.arrayOf(Object).isRequired,
  onDropDownChange: PropTypes.func.isRequired,
  enableErrorDisplay: PropTypes.bool,
  inputData: PropTypes.instanceOf(Object),
  onHeaderClick: PropTypes.func,
  onRowClick: PropTypes.func.isRequired,
  ledgerDetail: PropTypes.instanceOf(Array),
};

const defaultProps = {
  data: dataProps.defaultValue,
  pagination: paginationProps.defaultValue,
  onPageChange: () => null,
  onIconClick: () => null,
  enableErrorDisplay: false,
  inputData: {},
  onHeaderClick: () => null,
  ledgerDetail: [],
};

const View = ({ ...props }) => {
  const {
    data,
    onPageChange,
    pagination,
    distributorList,
    onDropDownChange,
    enableErrorDisplay,
    inputData,
    onHeaderClick,
    onRowClick,
    ledgerDetail,
  } = props;

  return (
    <StockLedgerStyled>
      <Fragment>
        {distributorList.length > 0 ? (
          <PanelStyled>
            <div>
              <CustomSelect
                small
                enableValidation
                options={distributorList}
                className='custom-select'
                placeholder='Select Distributor'
                getOptionValue={({ id }) => id}
                getOptionLabel={({ title }) => title}
                enableErrorDisplay={enableErrorDisplay}
                onChange={(event) => onDropDownChange(event.id)}
                value={distributorList.filter(({ id }) => id === inputData.distributorId) || []}
              />
            </div>
          </PanelStyled>
        ) : null}
        {data.list.length > 0 && (
          <CTAccordionStyled>
            <div className={`table-wrap ${distributorList.length === 0 ? 'no-select' : ''} `}>
              <table>
                {TableHeader({ onHeaderClick })}
                <Fragment>
                  <Detail data={data.list} onRowClick={onRowClick} ledgerDetail={ledgerDetail} />
                </Fragment>
              </table>
            </div>
          </CTAccordionStyled>
        )}
        {data.list.length > 0 && (
          <Pagination
            currentPage={pagination.page}
            limit={pagination.limit}
            totalItems={data.total}
            onPageChange={onPageChange}
          />
        )}
      </Fragment>
    </StockLedgerStyled>
  );
};

View.propTypes = propTypes;

View.defaultProps = defaultProps;

const ViewWithLoading = withLoading(View);

export default ViewWithLoading;
